import { Form, Switch, TextField, FormSelect } from "@/base";
import { SmtpPort } from "@sr-partner-portal/common";
import type { SubmitHandler, UseFormReturn } from "react-hook-form";

type CreateSmtpEmailProviderFormParameters = {
    email: string;
    password: string;
    smtpHost: string;
    smtpPort: string;
    smtpSecure: boolean;
};

interface SmtpEmailProviderCreateFormFormProps {
    id?: string;
    formController: UseFormReturn<
        CreateSmtpEmailProviderFormParameters,
        unknown,
        CreateSmtpEmailProviderFormParameters
    >;
    onSubmit: SubmitHandler<CreateSmtpEmailProviderFormParameters>;
}

const smtpPorts = Object.values(SmtpPort).map((port) => ({
    id: port,
    name: port,
}));

const SmtpEmailProvider__CreateFormForm = ({
    id,
    formController,
    onSubmit,
}: SmtpEmailProviderCreateFormFormProps) => {
    return (
        <Form
            id={id}
            controller={formController}
            onSubmit={onSubmit}
            className="flex flex-col gap-6"
        >
            <TextField<CreateSmtpEmailProviderFormParameters>
                fieldName="email"
                label="E-Mail-Adresse"
                autoComplete="smtp-email"
            />
            <TextField<CreateSmtpEmailProviderFormParameters>
                fieldName="password"
                type="password"
                label="Passwort"
                name="pin"
                autoComplete="new-password"
            />
            <TextField<CreateSmtpEmailProviderFormParameters>
                fieldName="smtpHost"
                label="SMTP-Host"
                autoComplete="off"
            />
            <div className="grid grid-cols-2 gap-6">
                <FormSelect
                    fieldName="smtpPort"
                    items={smtpPorts}
                    label="SMTP-Port"
                />
                <Switch fieldName="smtpSecure" label="SSL/TLS" />
            </div>
        </Form>
    );
};

export {
    SmtpEmailProvider__CreateFormForm,
    type CreateSmtpEmailProviderFormParameters,
};
